import SwitchField, { type SwitchProps } from '../../../../../components/fields/SwitchField';
import useSystemSwitchData from '../../../../../utilities/useSystemSwitchData';

const YesNoField = (props: SwitchProps) => {
    const { yesNoSwitch } = useSystemSwitchData();

    return <SwitchField {...props} {...yesNoSwitch} />;
};

export default YesNoField;
